import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import {  ui } from '../../../../../../../../../interfaces/interfaces';
import Grid from '@mui/material/Grid2';
import AccountCard from '../LastJobModal/AccountCard';
import BookingCard from '../LastJobModal/BookingCard';
import CustomerCard from '../LastJobModal/CustomerCard';
import EngineerCard from '../LastJobModal/EngineerCard';
import JobNotesCard from '../LastJobModal/JobNotesCard';
import PropertyCard from '../LastJobModal/PropertyCard';
import { getCompletionDetails, getJobDetails } from '../LastJobModal/helpers';
import { DialogTitle } from '@mui/material';
import { useAppSelector } from "@store/hooks";
import { RightioWBSAPIModelsSPSpJobsCompletionsGetCompletionsResult, RightioWBSAPIModelsSPSpJobsGetJobDetailsResult } from '../../../../../../../../../utilities/apis/wbs/endpoints';

const name = "JobHistoryModal";

interface JobHistoryModalProps {
    parent: string
}

const handleClose = () => {
    ui.JobHistoryModal = false;
};

const JobHistoryModal: React.FC<JobHistoryModalProps> = ({ parent }) => {
    const open = useAppSelector(({ ui }) => ui.JobHistoryModal)
    const completedJob = useAppSelector(({ state }) => state.CompletedJob)
    const [jobDetails, setJobDetails] = React.useState<RightioWBSAPIModelsSPSpJobsGetJobDetailsResult >()
    const [jobCompletion, setJobCompletion] = React.useState<RightioWBSAPIModelsSPSpJobsCompletionsGetCompletionsResult >()

    React.useEffect(() => {
        if (completedJob) {
            getJobDetails(completedJob).then(setJobDetails)
            getCompletionDetails(completedJob).then(setJobCompletion)
        }
    }, [completedJob])

    return (
        (<Dialog
            maxWidth="lg"
            open={open}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
            fullWidth
            PaperProps={{
                sx: {
                    backgroundColor: "#e7e7e7",
                },
            }}
            BackdropProps={{
                sx: {
                    backgroundColor: "#b9b9b9",
                },
            }}
        >
            <DialogTitle sx={{ backgroundColor: "#fff" }}>
                 Job History {jobDetails && jobDetails.jobId}
             </DialogTitle>
            <DialogContent dividers >
                <Grid container spacing={1} >
                    <Grid size={4}>
                        <AccountCard parent='JobHistoryModal' jobDetails={jobDetails} />
                        <EngineerCard parent='JobHistoryModal' jobDetails={jobDetails} />
                    </Grid>
                    <Grid size={4}>
                        <BookingCard parent='JobHistoryModal' jobDetails={jobDetails} />
                        <JobNotesCard parent='JobHistoryModal' jobDetails={jobDetails} jobCompletion={jobCompletion} />
                    </Grid>
                    <Grid size={4}>
                        {/* // card presenting address, each property should be align to right and value aligned to left */}
                        <PropertyCard parent='JobHistoryModal' jobDetails={jobDetails} />
                        <CustomerCard parent='JobHistoryModal' jobDetails={jobDetails} />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ backgroundColor: "#fff" }}>
                <Button variant='contained' onClick={handleClose} autoFocus>
                    Close
                </Button>
            </DialogActions>
        </Dialog >)
    );
}

JobHistoryModal.displayName = name;

export default React.memo(JobHistoryModal)